<template>
  <div>
    <b-modal
      title="DETALHES DO REAJUSTE"
      id="last_releases"
      size="md"
      hide-footer
      no-close-on-backdrop
    >
      <div class="row" v-if="last_releases_item">
        <div
          class="
            col-md-12
            pt-0
            pb-0
            border-bottom
            pb-2
            d-flex
            align-items-center
          "
        >
          <label class="m-0 mr-2">EXECUTADO?:</label>
          <div
            v-if="last_releases_item.executed == 1"
            class="d-flex align-items-center"
          >
            <span>SIM</span>
            <v-icon class="ml-2 c-success"> mdi-check-circle-outline </v-icon>
          </div>
          <div v-else class="d-flex align-items-center">
            <span>NÃO</span>
            <v-icon class="ml-2 c-warning"> mdi-information-outline </v-icon>
          </div>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">RESIDENTE:</label>
          <h6 class="m-0">{{ last_releases_item.resident_name }}</h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">NOME DA HOSPEDAGEM:</label>
          <h6 class="m-0">{{ last_releases_item.type_of_hosting_name }}</h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">DESCRIÇÃO DO VALOR DA HOSPEDAGEM:</label>
          <h6 class="m-0">
            {{ last_releases_item.hosting_type_value_description }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">VALOR ATUAL:</label>
          <h6 class="m-0">
            R$ {{ formatPrice(last_releases_item.cost_value) }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">PORCENTAGEM DE REAJUSTE(%):</label>
          <h6 class="m-0">{{ last_releases_item.profit }}</h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">NOVO VALOR:</label>
          <h6 class="m-0">
            R$ {{ formatPrice(last_releases_item.sale_value) }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">DATA DO REAJUSTE:</label>
          <h6 class="m-0">
            {{ moment(last_releases_item.date).format("DD/MM/YYYY") }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">QUEM FEZ:</label>
          <h6 class="m-0">
            {{
              professionalClassCouncilValue({
                id: last_releases_item.user_professional_class_council_id,
                name: last_releases_item.user_name,
                profile: last_releases_item.user_profile_name,
                office: last_releases_item.user_office,
                cpf: last_releases_item.user_cpf,
                value: last_releases_item.user_professional_class_council_value,
              })
            }}
          </h6>
        </div>
        <div class="col-md-12 pt-0 pb-0 d-flex align-items-center">
          <label class="m-0 mr-2">QUANDO FOI CRIADO:</label>
          <h6 class="m-0">
            {{
              moment(last_releases_item.created_at).format(
                "DD/MM/YYYY HH:mm:ss"
              )
            }}
          </h6>
        </div>
        <div
          class="col-md-12 text-right"
          v-if="last_releases_item.executed == 0"
        >
          <confirmation-dialog
            v-show="permission('remove', 'readjustment_type_of_hosting')"
            :disabled="loadingDelete"
            message-title="EXCLUIR?"
            message-body="Deseja realmente excluir o reajuste?"
            open-class="btn-cancel"
            open-left-icon="fa-times"
            open-text="EXCLUIR"
            @yes="deleteReadjustment"
          />
        </div>
      </div>
    </b-modal>
    <div
      class="row v-clean mt-2"
      v-show="permission('write', 'readjustment_type_of_hosting')"
    >
      <div class="col-md-4">
        <v-select-default
          item-text="name"
          item-value="id"
          :items="[
            { id: 'HOSPEDAGEM', name: 'HOSPEDAGEM' },
            { id: 'RESIDENTE', name: 'RESIDENTE' },
          ]"
          label="FILTRAR POR HOSPEDAGEM OU RESIDENTE"
          v-model="filter_type"
          @change="handleChangeFilterType"
        />
      </div>
      <div class="col-md-8" v-if="filter_type == 'RESIDENTE'">
        <v-select-default
          item-text="name"
          item-value="id"
          :items="residents"
          label="RESIDENTE"
          v-model="resident_id"
          @change="handleChangeResidentId"
        />
      </div>
      <div class="col-md-8" v-if="filter_type == 'HOSPEDAGEM'">
        <v-select-default
          item-text="name"
          item-value="id"
          :items="type_of_hosting"
          label="HOSPEDAGEM"
          v-model="type_of_hosting_id"
          @change="handleChangeTypeOfHostingId"
        />
      </div>
    </div>
    <div
      class="row v-clean mt-2"
      v-show="permission('write', 'readjustment_type_of_hosting')"
    >
      <div class="col-md-12">
        <h1 class="title-pages">
          {{
            filter_type == "HOSPEDAGEM"
              ? "VALORES"
              : "VALOR INFORMADO NO RESIDENTE"
          }}
        </h1>
        <div v-if="filter_type == 'HOSPEDAGEM'">
          <b-overlay :show="loadingHostingTypeValue" opacity="0.99">
            <div
              class="v-clean p-5 text-center"
              v-if="hosting_type_value.length == 0"
            >
              <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
            </div>
            <div v-if="hosting_type_value.length > 0">
              <v-select
                :items="hosting_type_value"
                v-model="hosting_type_value_id"
                dense
                label="VALORES"
                outlined
                hide-details
                item-value="id"
                :item-text="
                  (item) => {
                    return `${formatPrice(item.value)} - ${
                      item.description
                    } - CATEGORIA DO FINANCEIRO (${
                      item.finance_configuration_category_name
                        ? item.finance_configuration_category_name
                        : 'NÃO INFORMADO'
                    })`;
                  }
                "
                @change="handleChangeHostingTypeValueId"
              />
            </div>
            <div
              class="v-clean p-5 text-center"
              v-if="
                hosting_type_value_id && residents_type_of_hosting.length == 0
              "
            >
              <h6 class="text-center upper-text worksansr">
                VALOR DA HOSPEDAGEM NÃO POSSUE RESIDENTES!
              </h6>
            </div>
            <div
              class="mt-5"
              v-if="
                hosting_type_value_id && residents_type_of_hosting.length > 0
              "
            >
              <h1 class="title-pages">RESIDENTES</h1>
              <small class="text-muted"
                >SELECIONE O(S) RESIDENTE(S) QUE DESEJA FAZER O REAJUSTE</small
              >
              <v-data-table
                dense
                v-model="residents_selected"
                :headers="[{ text: 'NOME', value: 'name', sortable: false }]"
                :items="residents_type_of_hosting"
                item-key="name"
                show-select
                disable-pagination
                hide-default-footer
              >
                <template v-slot:[`item.action`]="{ item }">
                  {{ item }}
                </template>
              </v-data-table>
              <div v-if="residents_selected.length > 0">
                <div class="row">
                  <div class="col-md-3">
                    <v-text-field-default
                      label="VALOR ATUAL"
                      v-model="cost_value"
                      disabled
                    />
                  </div>
                  <div class="col-md-3">
                    <v-text-field-default
                      label="PORCENTAGEM DE REAJUSTE(%)"
                      v-model="profit"
                      @input="handleInputProfit"
                    />
                  </div>
                  <div class="col-md-3">
                    <v-text-field-default
                      label="NOVO VALOR (REAJUSTADO)"
                      v-model="sale_value"
                      @input="handleInputSaleValue"
                    />
                  </div>
                  <div class="col-md-3">
                    <v-text-field-default
                      label="DATA DO REAJUSTE"
                      v-model="date"
                      type="date"
                    />
                  </div>
                  <div class="col-md-12">
                    <errors-messages :errors="errors" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn-save
                      :disabled="loading"
                      :loading="loading"
                      @click="execute"
                    />
                  </div>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
        <div v-if="filter_type == 'RESIDENTE'">
          <b-overlay :show="loadingHostingTypeValue" opacity="0.99">
            <div
              class="v-clean p-5 text-center"
              v-if="!hosting_type_value_resident"
            >
              <h6 class="text-center upper-text worksansr">
                RESIDENTE NÃO POSSUE VALOR DA HOSPEDAGEM INFORMADO!
              </h6>
            </div>
            <div v-if="hosting_type_value_resident">
              <div class="row">
                <div class="col-md-4">
                  <v-text-field-default
                    label="DESCRIÇÃO"
                    :value="hosting_type_value_resident.description"
                    disabled
                  />
                </div>
                <div class="col-md-8" v-if="permission('read', 'financial')">
                  <v-text-field-default
                    label="CATEGORIA DO FINANCEIRO"
                    :value="
                      hosting_type_value_resident.finance_configuration_category_name
                        ? hosting_type_value_resident.finance_configuration_category_name
                        : 'NÃO INFORMADO'
                    "
                    disabled
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <v-text-field-default
                    label="VALOR ATUAL"
                    v-model="cost_value"
                    disabled
                  />
                </div>
                <div class="col-md-3">
                  <v-text-field-default
                    label="PORCENTAGEM DE REAJUSTE(%)"
                    v-model="profit"
                    @input="handleInputProfit"
                  />
                </div>
                <div class="col-md-3">
                  <v-text-field-default
                    label="NOVO VALOR (REAJUSTADO)"
                    v-model="sale_value"
                    @input="handleInputSaleValue"
                  />
                </div>
                <div class="col-md-3">
                  <v-text-field-default
                    label="DATA DO REAJUSTE"
                    v-model="date"
                    type="date"
                  />
                </div>
                <div class="col-md-12">
                  <errors-messages :errors="errors" />
                </div>
                <div class="col-md-12 text-right">
                  <v-btn-save
                    :disabled="loading"
                    :loading="loading"
                    @click="execute"
                  />
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>
    <div class="row v-clean mt-2">
      <div class="col-md-12">
        <h1 class="title-pages">ÚLTIMOS REAJUSTES</h1>
        <b-overlay :show="loadingLastReleases" opacity="0.99">
          <div class="v-clean p-5 text-center" v-if="last_releases.length == 0">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            dense
            v-show="last_releases.length > 0"
            :headers="[
              { text: 'EXECUTADO?', value: 'executed', sortable: false },
              { text: 'QUEM FEZ', value: 'user', sortable: false },
              { text: 'RESIDENTE', value: 'resident', sortable: false },
              {
                text: 'NOME DA HOSPEDAGEM',
                value: 'type_of_hosting',
                sortable: false,
              },
              {
                text: 'DESC. VALOR DA HOSPEDAGEM',
                value: 'hosting_type_value',
                sortable: false,
              },
              { text: 'NOVO VALOR', value: 'value', sortable: false },
              { text: 'DATA DO REAJUSTE', value: 'date', sortable: false },
              {
                text: 'QUANDO FOI CRIADO',
                value: 'created_at',
                sortable: false,
              },
            ]"
            :items="last_releases"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickLastReleases"
          >
            <template v-slot:[`item.executed`]="{ item }">
              <div
                v-if="item.executed == 1"
                class="d-flex align-items-center justify-content-center"
              >
                <span>SIM</span>
                <v-icon class="ml-2" small color="success">
                  mdi-check-circle-outline
                </v-icon>
              </div>
              <div
                v-else
                class="d-flex align-items-center justify-content-center"
              >
                <span>NÃO</span>
                <v-icon class="ml-2" small color="orange">
                  mdi-information-outline
                </v-icon>
              </div>
            </template>
            <template v-slot:[`item.user`]="{ item }">
              {{
                professionalClassCouncilValue({
                  id: item.user_professional_class_council_id,
                  name: item.user_name,
                  profile: item.user_profile_name,
                  office: item.user_office,
                  cpf: item.user_cpf,
                  value: item.user_professional_class_council_value,
                })
              }}
            </template>
            <template v-slot:[`item.resident`]="{ item }">
              {{ item.resident_name }}
            </template>
            <template v-slot:[`item.type_of_hosting`]="{ item }">
              {{ item.type_of_hosting_name }}
            </template>
            <template v-slot:[`item.hosting_type_value`]="{ item }">
              {{ item.hosting_type_value_description }}
            </template>
            <template v-slot:[`item.value`]="{ item }">
              R$ {{ formatPrice(item.sale_value) }}
            </template>
            <template v-slot:[`item.date`]="{ item }">
              {{ moment(item.date).format("DD/MM/YYYY") }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") }}
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import VSelectDefault from "../../../Components/VSelectDefault.vue";
import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";
import VBtnSave from "../../../Components/VBtnSave.vue";
import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import moment from "moment";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import permission from "../../../../lib/permission";

export default {
  name: "TypeOfHosting",

  components: {
    ErrorsMessages,
    VSelectDefault,
    VTextFieldDefault,
    VBtnSave,
    ConfirmationDialog,
  },

  data() {
    return {
      last_releases: [],
      last_releases_item: null,

      residents_selected: [],
      residents: [],
      type_of_hosting: [],
      hosting_type_value: [],
      residents_type_of_hosting: [],
      hosting_type_value_resident: null,

      filter_type: "HOSPEDAGEM",

      resident_id: "",
      type_of_hosting_id: "",
      hosting_type_value_id: "",

      date: "",
      cost_value: "",
      sale_value: "",
      profit: "",

      hosting_type_value_selected: false,

      loading: false,
      loadingHostingTypeValue: false,
      loadingLastReleases: false,
      loadingDelete: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatPrice,
    permission,
    professionalClassCouncilValue,
    moment,

    handleClickLastReleases(item) {
      this.last_releases_item = item;
      this.$bvModal.show("last_releases");
    },

    handleInputProfit(value) {
      let { cost_value } = this;

      if (value) {
        let profit = formatValueToPercentage(value);
        if (profit) {
          let current = formatValueToOnlyNumber(cost_value);
          let percentage = profit * current;
          let sale_value = percentage / 100;
          sale_value = parseFloat(sale_value) + parseFloat(current);
          this.sale_value = formatPrice(sale_value);
        }
      } else {
        this.sale_value = formatPrice(0);
      }
    },

    handleInputSaleValue(value) {
      this.sale_value = formatValueOnKeyUp(value);
    },

    handleChangeHostingTypeValueId() {
      let { type_of_hosting_id, hosting_type_value_id, hosting_type_value } =
        this;

      if (type_of_hosting_id && hosting_type_value_id) {
        this.getResidentsByTypeOfHosting();

        let hosting_type_value_selected = hosting_type_value.find(
          (value) => value.id == hosting_type_value_id
        );

        if (hosting_type_value_selected) {
          this.hosting_type_value_selected = hosting_type_value_selected;
          this.cost_value = formatPrice(
            String(hosting_type_value_selected.value)
          );
        }
      }

      this.residents_selected = [];
    },

    handleChangeFilterType() {
      this.errors = [];
      this.type_of_hosting_id = "";
      this.hosting_type_value_id = "";
      this.resident_id = "";
      this.hosting_type_value = [];
      this.residents_type_of_hosting = [];
      this.hosting_type_value_resident = null;
      this.date = "";
      this.cost_value = "";
      this.profit = "";
      this.sale_value = "";
    },

    handleChangeTypeOfHostingId() {
      let { type_of_hosting_id } = this;

      if (type_of_hosting_id) {
        this.getHostingTypeValue();
        this.getLastReleases();
      }

      this.residents_selected = [];
      this.residents_type_of_hosting = [];
      this.hosting_type_value_id = "";
      this.date = "";
      this.cost_value = "";
      this.profit = "";
      this.sale_value = "";
    },

    handleChangeResidentId() {
      let { resident_id, residents } = this;

      if (resident_id) {
        let resident = residents.find((resident) => resident.id == resident_id);
        if (resident) {
          this.type_of_hosting_id = resident.type_of_hosting_id;
          this.hosting_type_value_id = resident.hosting_type_value_id;
        } else {
          this.type_of_hosting_id = "";
          this.hosting_type_value_id = "";
        }

        this.getHostingTypeValueByResident();
        this.getLastReleases();
      }
    },

    retrieve() {
      this.getResidents();
      this.getTypeOfHosting();
      this.getLastReleases();
    },

    async getResidents() {
      try {
        const response = await api.get("/rest-home/residents");

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getTypeOfHosting() {
      try {
        const response = await api.get("/rest-home/type-of-hosting/paginate");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.type_of_hosting = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getHostingTypeValue() {
      try {
        this.loadingHostingTypeValue = true;

        let { type_of_hosting_id } = this;

        const params = { type_of_hosting_id };

        const response = await api.get("/rest-home/hosting-type-value/all", {
          params,
        });

        const { error, errors, hosting_type_value } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.hosting_type_value = hosting_type_value;
        }

        this.loadingHostingTypeValue = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getHostingTypeValueByResident() {
      try {
        this.loadingHostingTypeValue = true;

        let { resident_id } = this;

        const params = { resident_id };

        const response = await api.get(
          "/rest-home/hosting-type-value/by-resident",
          {
            params,
          }
        );

        const { error, errors, hosting_type_value } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.hosting_type_value_resident = hosting_type_value;

          if (hosting_type_value) {
            this.cost_value = formatPrice(hosting_type_value.value);
          } else {
            this.cost_value = formatPrice(0);
          }
        }

        this.loadingHostingTypeValue = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidentsByTypeOfHosting() {
      try {
        this.loadingResidents = true;

        let { type_of_hosting_id, hosting_type_value_id } = this;

        const params = { type_of_hosting_id, hosting_type_value_id };

        const response = await api.get(
          "/rest-home/residents-by-type-of-hosting",
          {
            params,
          }
        );

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents_type_of_hosting = residents;
        }

        this.loadingResidents = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getLastReleases() {
      try {
        this.loadingLastReleases = true;

        let { type_of_hosting_id, hosting_type_value_id, resident_id } = this;

        const params = {
          type_of_hosting_id,
          hosting_type_value_id,
          resident_id,
          type: "HOSPEDAGEM",
          limit: 25,
        };

        const response = await api.get("/rest-home/readjustment/last", {
          params,
        });

        const { error, errors, readjustment } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.last_releases = readjustment;
        }

        this.loadingLastReleases = false;
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loading = true;

        let {
          filter_type,
          resident_id,
          type_of_hosting_id,
          hosting_type_value_id,
          residents_selected,
          date,
          cost_value,
          sale_value,
          profit,
        } = this;

        let resident_ids = [];
        for (let resident of residents_selected) {
          resident_ids.push(resident.id);
        }

        const params = {
          filter_type,
          resident_id,
          type_of_hosting_id,
          hosting_type_value_id,
          resident_ids,
          date,
          cost_value,
          sale_value,
          profit,
        };

        const response = await api.post(
          "/rest-home/readjustment/type-of-hosting",
          params
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.handleChangeFilterType();
          this.getLastReleases();
        }

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async deleteReadjustment() {
      try {
        this.loadingDelete = true;

        const {
          last_releases_item: { id },
        } = this;

        let data = { id };

        const response = await api.delete("/rest-home/readjustment", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getLastReleases();
          toast(message, "success");
          this.$bvModal.hide("last_releases");
        } else {
          this.errors = errors;
        }

        this.loadingDelete = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
